<div class="confirm-dialog-wrap">
	<h3>{{message}}</h3>
  	<input id="inputValue" class="form-control form-control-sm" type="number" [min]="1"  pattern="[0-9]*" numberOnly="true" [(ngModel)]="inputValue" placeholder="">
	<div class="buttons-wrap">
		<button class="btn medium outline-danger m-r" [class.no-transition]="!transition" (click)="cancelClick()" tabindex="-1"><i class="icon icon-cross-circle"></i>{{cancelButtonText}}</button>
		<button class="btn primary medium" [class.no-transition]="!transition" [class.disabled]="!inputValue"  (click)="confirmClick()" tabindex="1"><i class="sporticon sporticon-circle-add"></i> {{confirmButtonText}}</button>
	</div>
</div>
